





import { Vue, Component } from 'vue-property-decorator';
import { getAdapter, env } from '@zyf2e/adapt';
import Confirm from './components/Confirm.vue';
import { ROUTE_PATH } from '../../constant';

@Component({ components: { Confirm } })
export default class CheckoutConfirm extends Vue {
  handleSuccess(orderInfo: any) {
    if (Number(orderInfo.backEventType) === 1 && env.inWechat) {
      try {
        const adarpt = getAdapter();
        (adarpt as any).wx.closeWindow();
      } catch (error) {
        // do nothing
      }
      return;
    }
    if (orderInfo.successUrl) {
      window.location.replace(decodeURIComponent(orderInfo.successUrl));
      return;
    }
    this.$router.replace({
      name: ROUTE_PATH.success,
      query: {
        ...orderInfo
      }
    });
  }

  handleFail(orderInfo: any) {
    if (orderInfo.failUrl) {
      window.location.replace(decodeURIComponent(orderInfo.failUrl));
      return;
    }
    this.$router.replace({
      name: ROUTE_PATH.fail,
      query: {
        ...orderInfo
      }
    });
  }
}
